module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Contact information","spb":"St. Petersburg","msk":"Moscow","address1":"21&nbsp;Tsvetochnaya&nbsp;St., lit. A","address2":"36&nbsp;Berzarina&nbsp;St., building&nbsp;3"},"ru":{"title":"Контакты","spb":"Санкт-Петербург","msk":"Москва","address1":"ул. Цветочная, д.&nbsp;21, лит. А","address2":"ул. Берзарина, д.&nbsp;36, стр.&nbsp;3"}}')
  delete Component.options._Ctor
}
